import { Temporal } from 'temporal-polyfill';

/**
 * This reviver function is intended to be used in conjunction with tasks that
 * use `JSON.parse`. It is highly unlikely that you need to call this function
 * in day-to-day scenarios.
 *
 * See `docs/DATA_SERVICE.md` for more.
 */
export function reviver(this: any, key: string, value: any): any {
  if (key.endsWith('PlainDate') && value) {
    return Temporal.PlainDate.from(value);
  }

  if (key.endsWith('PlainTime') && value) {
    return Temporal.PlainTime.from(value);
  }

  if (key.endsWith('Instant') && value) {
    return Temporal.Instant.from(value);
  }

  if ((key.endsWith('Duration') || key === 'duration') && value) {
    return typeof value === 'string' ? Temporal.Duration.from(value) : value;
  }

  return value;
}
